// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"302":"book-view","372":"home-view","855":"books-view"}[chunkId] + "." + {"302":"93dc6db9","372":"93dc6db9","855":"93dc6db9"}[chunkId] + ".chunk.css";
};